<app-operaciones-usuario [titulo]="titulo" [usuarios]="usuarios" [operacion]="operacion"
    (funcion)="cambiarRolUsuario($event)" (refresh)="refresh()"></app-operaciones-usuario>